<template>
    <v-bottom-navigation
            app
            fixed
            grow
            v-model="activeItem"
            color="primary"
    >
        <v-btn
                v-if="showCorrect"
                value="top">
            <span>{{ $t('nav.correct')}}</span>
            <v-icon>done</v-icon>
        </v-btn>
        <v-btn
                v-if="showWrong"
                value="code">
            <span>{{ $t('nav.wrong') }}</span>
            <v-icon>close</v-icon>
        </v-btn>
        <v-btn
                v-if="showShowAnswer"
                value="code">
            <span>{{ $t('nav.showAnswer') }}</span>
            <v-icon>close</v-icon>
        </v-btn>
        <v-btn
                v-if="showFinished"
                value="code">
            <span>{{ $t('nav.finished') }}</span>
            <v-icon>close</v-icon>
        </v-btn>

        <v-btn value="favorites">
            <span>Favorites</span>
            <v-icon>favorite</v-icon>
        </v-btn>
    </v-bottom-navigation>
</template>

<script>
    export default {
        name: "BottomNav",
        data: function () {
            return {
                activeItem: null,
            }
        },
        computed: {
            showCorrect () {
                return this.$store.state.bottomNav.backShowing;
            },
            showWrong () {
                return this.$store.state.bottomNav.backShowing;
            },
            showShowAnswer () {
                return this.$store.state.bottomNav.frontShowing;
            },
            showFinished () {
                return this.$store.state.bottomNav.frontShowing;
            }
        }
    }
</script>

<style scoped>

</style>
